import { Tooltip, TooltipTrigger } from 'react-aria-components';
import IconButton from '~/components/buttons/NewIconButton';
import ReviewFillIcon from '~/icons/icon-review-fill.svg?react';
import { BookkeepingTransaction } from '~/types/general-bookkeeping';
import styles from './GeneralBookkeepingCashBookTooltip.module.scss';
import GeneralBookkeepingCashBookTooltipContent from './GeneralBookkeepingCashBookTooltipContent';

interface GeneralBookkeepingCashBookTooltipProps {
  bookkeepingTransaction: BookkeepingTransaction;
}

const GeneralBookkeepingCashBookTooltip = ({ bookkeepingTransaction }: GeneralBookkeepingCashBookTooltipProps) => (
  <TooltipTrigger delay={0} closeDelay={0}>
    <IconButton Icon={ReviewFillIcon} variant="ghost" size="large" className={styles.previewTrigger} />

    <Tooltip className={styles.tooltip} data-testid="cash-book-tooltip" placement="top end" crossOffset={-48}>
      <GeneralBookkeepingCashBookTooltipContent bookkeepingTransaction={bookkeepingTransaction} />
    </Tooltip>
  </TooltipTrigger>
);

export default GeneralBookkeepingCashBookTooltip;
